// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PartnerGoodwillDiscount from "../entity/PartnerGoodwillDiscount.bs.js";

function execute(json) {
  return DeccoUtils$Catalyst.resolveResult(PartnerGoodwillDiscount.t_decode(json), "PartnerGoodwillBonusEntityMapper.re - PartnerGoodwillDiscount ");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
